module.exports = __webpack_public_path__ + "static/media/manguera-rojo.2ed9326e.svg";